module.exports = __webpack_public_path__ + "img/ro.470a8d98.svg";